import React from 'react';

import SEO from "components/Seo";
import Header from "components/Header";
import Footer from "components/Footer";

import LayoutMain from "components/layout/layoutMain";
import LayoutPanel from "components/layout/layoutPanel";

import Link from "components/common/Link";
import Faq from 'components/common/Faq';

import ffc from "images/fremantle-dockers/FFC_Horiz_C-RGB.svg";
import fixtures from "images/fremantle-dockers/flowmoji-afl-footy-fixtures_light_RGB.svg";
import merch from "images/fremantle-dockers/flowmoji-FREO-merch_RGB.svg";
import football from "images/fremantle-dockers/header-image_FFC_KH-football.png";

import rac from "images/rac/natural-gas/logo-rac.png";
import flybuys from "images/flybuys/logo-flybuys.png";
import cinemas from "images/telethon-community-cinemas/logo-communitycinemas.png";
import goodFood from "images/good-food-and-wine/gfws-hero-badge-2.png";

import faqData from "../../../constants/components/accordion-list/fremantle-dockers-faq.json"

import "styles/pages/fremantle-dockers.css";

export default function() {
    return (
        <>
            <SEO
                title="Fremantle Dockers | Kleenheat sponsorship"
                titleBespoke="true"
                description="We've partnered with the Fremantle Dockers to deliver unforgettable experiences on and off the field with exclusive offers available for Kleenheat customers."
            />
            <Header />
            <LayoutMain>
                <LayoutPanel
                    background="mer-bg--primary-cyan"
                    padding="mer-py-lg"
                    theme="mer-theme--cyan"
                >
                    <div className="container ffc-hero-banner">
                        <div className="row mer-panel justify-content-center">
                            <div className="col-10 col-sm-7 col-lg-6 mer-text--size-lg">
                                <div className="mer-pb-lg">
                                    <img className="logo-ffc" src={ffc} alt="Fremantle Dockers and Kleenheat AFL Football" />
                                </div>
                                <section>
                                    <div className="content">
                                        <h2>A partnership made in WA</h2>
                                        <p>We're all for WA, and we know WA loves its footy.</p>
                                        <p>We've partnered with the Fremantle Dockers to deliver unforgettable experiences on and off the field.</p>
                                        <p>Kleenheat customers can access ticket offers, giveaways and discounted merchandise.</p>
                                        <div className="mer-panel__actions mer-button-group">
                                            <Link
                                                text="Customer benefits"
                                                link="#customer-benefits"
                                                linkClass="mer-button mer-button--primary"
                                            />
                                            <Link
                                                text="Learn more"
                                                link="/blog/community/kleenheat-partners-with-fremantle-dockers"
                                                linkClass="mer-button mer-button--secondary"
                                            />
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="col-8 col-sm-5 col-lg-5 mer-panel__images mt-3 mt-lg-0 p-lg-0 football">
                                <img src={football} className="mer-panel__image" alt="Fremantle Dockers and Kleenheat AFL Football" />
                            </div>
                        </div>
                    </div>
                </LayoutPanel>
                <LayoutPanel
                    background="mer-bg--ui-white"
                    padding="mer-py-lg"
                    margin="football-margin ffc-sub-hero-panel"
                    theme="mer-theme--light"
                    id="customer-benefits"
                >
                    <div className="container">
                        <div className="row mer-panel align-items-center justify-content-center">
                            <div className="col-10 col-sm-8 col-lg-6 mer-text--size-lg text--size-lg">
                                <div className="content text-center">
                                    <h2 className="mer-color--primary-cyan">Kleenheat customer benefits</h2>
                                </div>
                            </div>
                            <div className="col-10 col-lg-8">
                                <div className="row mer-panel mer-py-de">
                                    <div className="col-6 col-sm-4 mer-px-de mer-panel__images mb-0">
                                        <img className="mer-panel__image" src={merch} alt="Fremantle Football Club Merchandise" />
                                    </div>
                                    <div className="col-12 col-sm-7 offset-sm-1 content">
                                        <h4>10% off merchandise</h4>
                                        <p>Get 10% off Freo Dockers merchandise <a target="_blank" href="https://teamstore.fremantlefc.com.au">online</a> or in-store.</p>
                                        <p>Use the code <strong>KLEENHEAT10</strong> at the checkout.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </LayoutPanel>
                <LayoutPanel
                    background="mer-bg--ui-light"
                    padding="mer-py-lg"
                    theme="mer-theme--light"
                >
                    <div className="container">
                        <div className="row mer-panel align-items-center justify-content-center">
                            <div className="col-10 col-sm-8 col-lg-6 mer-text--size-lg text--size-lg">
                                <div className="content text-center">
                                    <h2>Catch all the action</h2>
                                </div>
                            </div>
                            <div className="col-10 col-lg-8">
                                <div className="row mer-panel mer-py-de">
                                    <div className="col-6 col-sm-4 mer-panel__images mb-0">
                                        <img className="mer-panel__image" src={fixtures} alt="Fremantle Dockers Tickets" />
                                    </div>
                                    <div className="col-12 col-sm-7 offset-sm-1 content">
                                        <h4>Freo fixtures</h4>
                                        <p>Keen to catch a Freo game at Optus Stadium?</p>
                                        <p>View the <a target="_blank" href="https://www.fremantlefc.com.au/footy/fixture">fixtures</a> to see when and where Freo is playing this season.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </LayoutPanel>
                <Faq panelBackground="mer-bg--ui-light"
                    panelPadding="mer-py-lg"
                    data={faqData}
                    id="faq"
                />
                <LayoutPanel
                    background="mer-bg--ui-white"
                    padding="mer-py-lg"
                    theme="mer-theme--light"
                >
                    <div className="container">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-10 col-sm-7 col-lg-7">
                                <div className="content text-center">
                                    <h2 className="mer-color--primary-cyan">Our other partnerships and sponsorships</h2>
                                </div>
                            </div>
                            <div className="col-10 col-sm-12 col-lg-8">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-5 col-sm-3 mer-p-de">
                                        <a href="/rac" title="Open Kleenheat RAC page" className="mer-link--hover-none">
                                            <img className="mer-panel__image" src={rac} alt="RAC logo" />
                                        </a>
                                    </div>
                                    <div className="col-5 col-sm-3 mer-p-de">
                                        <a href="/flybuys" title="Open Kleenheat Flybuys page" className="mer-link--hover-none">
                                            <img className="mer-panel__image" src={flybuys} alt="flybuys logo" />
                                        </a>
                                    </div>
                                    <div className="col-5 col-sm-3 mer-p-de">
                                        <a href="/about/community/telethon-community-cinemas" title="Open Telethon Community Cinemas page" className="mer-link--hover-none">
                                            <img className="mer-panel__image" src={cinemas} alt="Telethon Community Cinemas" />
                                        </a>
                                    </div>
                                    <div className="col-5 col-sm-3 mer-p-de">
                                        <a href="/about/community/good-food-wine-show" title="Open Good Food Wine Show page" className="mer-link--hover-none">
                                            <img className="mer-panel__image" src={goodFood} alt="Good Food &amp; Wine Show" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </LayoutPanel>
            </LayoutMain>
            <Footer />
        </>
    )
}